import { includes } from 'lodash';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormArray, FormControl } from '@angular/forms';
import { MatFormField } from '@angular/material/form-field';
import { MatTooltip } from '@angular/material/tooltip';
import { ComponentDefinition } from '@formbird/types';
import { ChangedDocumentService } from 'formbird-services';
import { FormbirdInjectorService } from '@services/injector/formbird-injector.service';
import { ComponentSetupService } from '../../../../formbird-sc-shared/src/lib/component-setup.service';
import { AbstractComponent } from '../../../../formbird-sc-shared/src/lib/components/abstract.component';
import * as _ from 'lodash';

interface CheckListComponentDefinition extends ComponentDefinition {
  list?: string[];
}

@Component({
  templateUrl: './check-list.component.html',
  styleUrls: ['./check-list.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class CheckListComponent extends AbstractComponent<CheckListComponentDefinition> implements OnInit {

  checkList: any;
  private listCopy: any;

  constructor(
    protected formbirdInjectorService: FormbirdInjectorService,
    protected changedDocumentService: ChangedDocumentService,
    protected componentSetupService: ComponentSetupService,
    protected cdr: ChangeDetectorRef
  ) {
    super(formbirdInjectorService, changedDocumentService, componentSetupService, cdr);
  }

  ngOnInit() {

    this.componentSetupService.setupStandardProperties(this);

    this.initializeFieldValue();

    this.checkList = {items: this.createListItems()};

    this.setFieldActivation(false);

    this.setupChangeDetection();

    const compSub = this.changedDocumentService.watchComponentDef(this.fieldName, this.template.documentId).subscribe(tplItem => {
      this.onComponentDefChanged(tplItem);
      // Condition watch for componentDefinition.list.
      if (!(_.isEqual(this.listCopy, tplItem?.list))) {
        this.checkList = { items: this.createListItems() };
        this.initializeFieldValue();
        this.setFieldActivation(false);
        this.detectChanges();
      }// End Condition watch for componentDefinition.list

    });
    this.subs.add(compSub);

  }

  initializeFieldValue() {
    // this block code will be used when the component reset
    if (this.checkList) {
      this.setFormValues(this.fieldValue);
    }
  }

  onFieldValueChanged(fieldValue) {
    this.fieldValue = fieldValue;
    this.setFormValues(fieldValue);
    this.detectChanges();
  }

  setFieldActivation(shouldDetectChanges?) {
    this.checkList.items.controls.forEach((checkControl: FormControl) => {
      if (this.disabled) {
        checkControl.disable({emitEvent: false});
      } else {
        checkControl.enable({emitEvent: false});
      }
    });

    this.detectChanges(shouldDetectChanges);

  }

  setFormValues(fieldValue) {
    if (fieldValue) {
      this.checkList.items.controls.map((item, i) => {
        const itemValue = this.componentDefinition.list[i];
        const isChecked = fieldValue.includes(itemValue);
        item.patchValue(isChecked);
      });
    } else {
      this.checkList.items.controls.map((item, i) => {
        item.patchValue(false);
      });
    }

  }

  createListItems() {
    const arr = this.componentDefinition.list.map(item => {
      const fldVal = this.document[this.componentDefinition.name];
      const value = (fldVal && fldVal.includes(item)) || false;
      return new FormControl(value);
    });
    this.listCopy = [...this.componentDefinition.list];
    return new FormArray(arr);
  }

  onChange() {
    let docs: any = [];
    this.checkList.items.controls.map((item, i) => {
      if (item.value === true) {
        docs.push(this.componentDefinition.list[i]);
      }
    });

    if (docs.length === 0) {
      docs = '';
    }
    this.valueChanged(docs);
  }

  showToolTip(tooltip: MatTooltip, formFieldContainer: MatFormField, labelContainer: HTMLElement) {
    return (labelContainer.offsetWidth <= formFieldContainer._elementRef.nativeElement.scrollWidth);
  }

  toggleTooltip(tooltip: MatTooltip) {
    setTimeout(() => {
      tooltip.toggle();
    });
  }
}
